'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.MyFileInput = void 0;

var _stringify = require('babel-runtime/core-js/json/stringify'),
    _stringify2 = _interopRequireDefault(_stringify),
    _extends2 = require('babel-runtime/helpers/extends'),
    _extends3 = _interopRequireDefault(_extends2),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _uuid = require('uuid'),
    _Button = require('office-ui-fabric-react/lib/Button'),
    _Spinner = require('office-ui-fabric-react/lib/Spinner'),
    _Stack = require('office-ui-fabric-react/lib/Stack'),
    _Link = require('office-ui-fabric-react/lib/Link'),
    _ProgressIndicator = require('office-ui-fabric-react/lib/ProgressIndicator'),
    _Image = require('office-ui-fabric-react/lib/Image');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var FirebaseFileInput = function FirebaseFileInput() {
  return null;
};

if ('undefined' != typeof window) var _require = require('@appsparkler/react-hfn-components'),
    _FirebaseFileInput = _require.FirebaseFileInput;

var CustomFileInput = function CustomFileInput(a, b) {
  var c = a.type,
      d = a.required,
      e = a.name,
      f = a.progress,
      g = a.isUploading,
      h = a.uploaded,
      i = a.maxBytes,
      j = a.maxBytesError,
      k = a.isVerifying,
      l = a.file,
      m = a.handleInput,
      n = a.maxBytesExceeded,
      o = a.label,
      p = o === void 0 ? {} : o,
      q = p.readOnly,
      r = p.inputProps,
      s = p.disabled;
  return _react2.default.createElement(_Stack.Stack, null, !!l && 'contentType' in l && l.contentType.startsWith('image') && _react2.default.createElement(_Image.Image, {
    src: l.downloadURL,
    width: 200,
    alt: 'Loading...'
  }), _react2.default.createElement(_Stack.Stack, {
    horizontal: !0
  }, k && _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  }), l && !k && !g && !f && _react2.default.createElement(_Link.Link, {
    target: '_blank',
    href: l.downloadURL,
    download: l.fileName
  }, l.fileName), _react2.default.createElement('input', (0, _extends3.default)({}, r, {
    style: {
      width: '0.1px',
      height: '0.1px',
      opacity: '0',
      overflow: 'hidden',
      position: 'absolute',
      zIndex: '-1'
    },
    type: c,
    name: e,
    onInput: m,
    ref: b,
    disabled: q,
    required: d,
    id: e
  })), !q && !k && !g && !f && _react2.default.createElement('label', {
    htmlFor: e
  }, l ? _react2.default.createElement(_Button.ActionButton, {
    style: {
      marginTop: '-6px'
    },
    iconProps: {
      iconName: 'Edit'
    },
    disabled: s,
    onClick: function b(a) {
      return a.currentTarget.parentElement.click();
    },
    text: 'Change File'
  }) : _react2.default.createElement(_Button.DefaultButton, {
    style: {
      marginTop: '-6px'
    },
    iconProps: {
      iconName: 'Upload'
    },
    disabled: s,
    onClick: function b(a) {
      return a.currentTarget.parentElement.click();
    },
    text: 'Upload File'
  })), (g || f) && _react2.default.createElement(_ProgressIndicator.ProgressIndicator, {
    label: 'uploading',
    description: f.toFixed(2) + '%',
    percentComplete: f
  }), n && _react2.default.createElement('p', {
    className: 'alert alert-danger'
  }, j, ': ', Math.round(i / 1048576), 'MB')));
},
    CustomFileLink = function CustomFileLink(a) {
  // YOU HAVE THESE PROPS for CUSTOM FILE LINK
  var b = a.isVerifying,
      c = a.file;
  return _react2.default.createElement('div', null, b && 'isVerifying...', c && !b && _react2.default.createElement('a', {
    href: c.downloadURL
  }, !!c && 'contentType' in c && c.contentType.startsWith('image') && _react2.default.createElement(_Image.Image, {
    src: c.downloadURL,
    width: 200,
    alt: 'Loading...'
  })));
},
    components = {
  fileInput: _react2.default.forwardRef(CustomFileInput),
  fileLink: CustomFileLink // PARAMS
  // 'file'
  // 'setFile'
  // 'firebaseStorage'
  // 'readOnly'
  // 'config'
  // 'namespace'

},
    MyFileInput = exports.MyFileInput = function (a) {
  var b = a.firebaseStorage,
      c = a.file,
      d = a.setFile,
      e = d === void 0 ? function () {} : d,
      f = a.readOnly,
      g = a.config,
      h = g === void 0 ? {} : g,
      i = a.namespace,
      j = i === void 0 ? 'na' : i,
      k = a.inputProps,
      l = k === void 0 ? {} : k,
      m = !c ? c : JSON.parse(c),
      n = !m || !('fullPath' in m) || !m.fullPath ? j + '/' + (0, _uuid.v4)() : m.fullPath,
      o = b.ref(n);

  var p = _react2.default.useMemo(function () {
    return (0, _uuid.v4)();
  }, []),
      q = (0, _extends3.default)({
    storageRef: o,
    components: components,
    onUpload: function b(a) {
      return e((0, _stringify2.default)(a));
    },
    readOnly: !!f,
    disabled: !!f,
    type: 'file',
    name: p,
    // OPTIONAL Validation PARAMETERS
    maxBytes: 204800,
    // default 200kb
    maxBytesError: 'file size exceeds allowed limit',
    maxBytesInfoMessage: 'max bytes : '
  }, h, {
    label: {
      inputProps: l,
      disabled: !!f,
      readOnly: !!f
    } // hijacking label variable to pass inputProps to custom components

  }); //console.log(params);


  return _react2.default.createElement(FirebaseFileInput, q);
};